import { cn } from '@/lib/utils';
import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

const HubertInput = forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'border-input flex w-full rounded-md border',
        'bg-transparent',
        'text-sm',
        'h-9 px-3 py-1',
        'file:text-foreground placeholder:text-muted-foreground focus-visible:ring-ring shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-1 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});

HubertInput.displayName = 'HubertInput';
export default HubertInput;
